<template>
  <div class="tooltip-history">
    <span class="tooltip-action-history-title">{{ $i18nPresenter.t(actionTitle) }}</span>
    <div class="container-shortcut-key">
      <div class="shortcut-key" v-html="getCommand()" />
      <div class="shortcut-key">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
        >
          <rect
            x="0.616455"
            y="0.5"
            width="18"
            height="18"
            rx="4"
            fill="#3F4557"
          />
          <path d="M7.01729 14.0128C6.74434 14.0128 6.53756 13.9403 6.39695 13.7952C6.26461 13.6416 6.20671 13.4453 6.22326 13.2063C6.24807 12.9673 6.35146 12.7198 6.53342 12.4638L10.9006 6.35714H6.89322C6.42176 6.35714 6.18604 6.1267 6.18604 5.66582C6.18604 5.21348 6.42176 4.9873 6.89322 4.9873H12.0296C12.3025 4.9873 12.5052 5.06412 12.6375 5.21774C12.7781 5.36284 12.8402 5.55487 12.8236 5.79384C12.8071 6.02428 12.7037 6.27179 12.5135 6.53637L8.1463 12.643H12.3398C12.8112 12.643 13.047 12.8692 13.047 13.3215C13.047 13.7824 12.8112 14.0128 12.3398 14.0128H7.01729Z" fill="white" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import Util from '@/util'

export default {

  name: 'TooltipHistory',
  props: {
    action: {
      type: String,
      required: true,
      validator: (value) => ['undo', 'redo'].includes(value),
    },
  },
  computed: {
    actionTitle() {
      return this.action.charAt(0).toUpperCase() + this.action.slice(1)
    },
  },
  methods: {
    getCommand() {
      return this.detectIOS() ?
        '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">\n' +
          '<rect x="0.622314" y="0.5" width="17.9971" height="18" rx="4" fill="#3F4557"/>\n' +
          '<path d="M6.28856 4.52362C5.85481 4.60564 5.50705 4.78742 5.2101 5.08631C4.41104 5.88343 4.42859 7.16897 5.25111 7.9466C5.4992 8.18306 5.79034 8.34516 6.13422 8.43697C6.32375 8.48583 6.35303 8.48777 6.98019 8.49756L7.62888 8.50542V9.49789V10.4904L6.98019 10.5001C6.48585 10.508 6.29835 10.5177 6.20256 10.5392C5.4231 10.7267 4.84479 11.3011 4.66699 12.067C4.61231 12.2976 4.61619 12.7294 4.67484 12.9619C4.76472 13.3214 4.92498 13.6106 5.1848 13.8802C5.98191 14.7066 7.28123 14.7027 8.07049 13.8685C8.30685 13.6204 8.46905 13.3292 8.56086 12.9853C8.60972 12.7958 8.61166 12.7665 8.62145 12.1394L8.62931 11.4907H9.62177H10.6142L10.624 12.1413C10.6338 12.8133 10.6416 12.8955 10.7315 13.1514C10.8995 13.632 11.2726 14.058 11.7239 14.2826C12.5152 14.6754 13.4374 14.519 14.0489 13.8899C14.3966 13.5323 14.5842 13.1103 14.6154 12.6141C14.6721 11.7329 14.1153 10.8987 13.2752 10.6077C13.0193 10.5178 12.9372 10.5099 12.2651 10.5002L11.6145 10.4905V9.49799V8.50552L12.2651 8.49767C12.8884 8.48787 12.9215 8.48594 13.1091 8.43707C14.6331 8.03464 15.1332 6.14927 14.004 5.06101C13.7344 4.80119 13.4453 4.64093 13.0857 4.55106C12.8532 4.4924 12.4214 4.48853 12.1908 4.54321C11.4249 4.72101 10.8506 5.29931 10.663 6.07888C10.6415 6.17457 10.6318 6.36217 10.6239 6.85457L10.6141 7.5052H9.62167H8.6292L8.62135 6.85457C8.61156 6.23129 8.60962 6.19813 8.56076 6.01053C8.36928 5.28768 7.82026 4.74254 7.09149 4.553C6.89032 4.50016 6.48595 4.48649 6.28856 4.52362ZM6.80045 5.51415C7.16188 5.57862 7.4725 5.86384 7.58196 6.22527C7.61317 6.32687 7.61715 6.42062 7.61909 6.91884V7.4952H7.04273C6.5445 7.49327 6.45076 7.48939 6.34915 7.45807C5.86266 7.31158 5.55204 6.82509 5.63406 6.3386C5.7024 5.93811 6.01701 5.60596 6.40577 5.5219C6.55624 5.48875 6.65396 5.48681 6.80045 5.51415ZM12.8278 5.51996C13.3397 5.62942 13.6933 6.13927 13.6093 6.64729C13.5468 7.02636 13.2771 7.33698 12.9157 7.45226C12.7848 7.49327 12.7438 7.4952 12.2006 7.4952H11.6243V6.91884C11.6243 6.37573 11.6262 6.33462 11.6672 6.20374C11.7746 5.86578 12.0658 5.59616 12.4018 5.5219C12.5601 5.48681 12.6696 5.48681 12.8278 5.51996ZM10.6181 9.49789V10.4943H9.62167H8.62523V9.49789V8.50144H9.62167H10.6181V9.49789ZM7.61909 12.0768C7.61909 12.6199 7.61715 12.661 7.57614 12.7919C7.42772 13.2609 6.95683 13.5598 6.4781 13.4874C5.93693 13.4034 5.55591 12.8974 5.63212 12.3621C5.69465 11.9264 6.02874 11.5844 6.46249 11.5122C6.5191 11.5024 6.80249 11.4966 7.09159 11.4985L7.61909 11.5005V12.0768ZM12.9254 11.5454C13.3884 11.6978 13.6815 12.1686 13.6112 12.6415C13.5272 13.1826 13.0114 13.5695 12.4781 13.4855C12.103 13.4289 11.7884 13.1612 11.6692 12.8017C11.6302 12.6845 11.6263 12.6239 11.6184 12.1101C11.6146 11.8014 11.6165 11.5337 11.6223 11.5181C11.6321 11.4908 11.7043 11.4888 12.2162 11.4947C12.7477 11.5024 12.8082 11.5063 12.9254 11.5454Z" fill="white"/>\n' +
          '</svg>'
        :
        '<div class="shortcut-key short-key-ctrl">Ctrl</div>'
    },
    detectIOS() {
      return Util.isMacOS()
    },
  },
}
</script>
<style scoped>
.tooltip-history {
  display: flex;
  @apply bg-secondary-100 text-base-0 rounded text-sm;
  pointer-events: none;
  align-items: center;
  .tooltip-action-history-title{
    font-size: 12px;
  }
  .container-shortcut-key{
    display: flex;
    padding: 2px 0;
    padding-left: 8px;
    color: #FFFFFF;
    .shortcut-key{
      &.short-key-ctrl{
        display: flex;
        align-items: center;
      }
      &:not(:last-child){
        margin-right: 4px;
      }
      padding: 4px;
      background: #3F4557;
      border-radius: 4px;
      gap: 10px;
    }
  }
}
</style>
